var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBmJobComments = function SvgBmJobComments(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7,6.643a.643.643,0,0,0,.643.643h9a.643.643,0,0,0,0-1.286h-9A.643.643,0,0,0,7,6.643Z",
    transform: "translate(-2.143 -2.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7,10.643a.643.643,0,0,0,.643.643h9a.643.643,0,0,0,0-1.286h-9A.643.643,0,0,0,7,10.643Z",
    transform: "translate(-2.143 -3.571)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7,14.643a.643.643,0,0,0,.643.643h5.143a.643.643,0,0,0,0-1.286H7.643A.643.643,0,0,0,7,14.643Z",
    transform: "translate(-2.143 -5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.643,18a.681.681,0,0,1-.27-.058A.643.643,0,0,1,1,17.357V3.214A3.214,3.214,0,0,1,4.214,0H15.786A3.214,3.214,0,0,1,19,3.214v7.714a3.214,3.214,0,0,1-3.214,3.214h-9.4l-4.32,3.7A.643.643,0,0,1,1.643,18ZM4.214,1.286A1.929,1.929,0,0,0,2.286,3.214V15.962l3.439-2.951a.643.643,0,0,1,.418-.154h9.643a1.929,1.929,0,0,0,1.929-1.929V3.214a1.929,1.929,0,0,0-1.929-1.929Z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBmJobComments, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BM_JobComments.670558dd.svg";
export { ForwardRef as ReactComponent };